module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/redux-form/~/react-lazy-cache/noGetters.js
// module id = 2122
// module chunks = 0